import React from 'react';

import { getValueFromEventContainingOnlyNumeric } from 'components/BaseForm/utils';
import { Input } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { FilterDashboardFourriereProps } from '../../../types';

function InputCodePostal({
  values,
}: FilterDashboardFourriereProps): React.ReactElement {
  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: 'codePostal',
        itemProps: {
          label: 'Code postal',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
          getValueFromEvent: getValueFromEventContainingOnlyNumeric,
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Number }}
    />
  );
}

export default InputCodePostal;
